import { render, staticRenderFns } from "./PricePopup.vue?vue&type=template&id=28a2c28c"
import script from "./PricePopup.vue?vue&type=script&lang=ts"
export * from "./PricePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports